import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import { UnidadePrimariaService } from "../../services/UnidadePrimariaService";
export default {
    name: "GerenciarUnidadesPrimarias",
    components: {
        Breadcrumb,
        StandardPagination,
        ActionButtons
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Unidades Primárias',
                disabled: false,
                href: '/unidades-primarias',
            },
            {
                text: 'Gerenciamento de Unidades Primárias',
                disabled: true
            }
        ],
        headers: [
            { text: 'Descrição', align: 'center', value: 'descricao', sortable: true },
            { text: 'Tipo', align: 'center', value: 'type', sortable: true },
            { text: 'Valor Total', align: 'center', value: 'valor_total', sortable: true },
            { text: 'Valor Disponível', align: 'center', value: 'valor_disponivel', sortable: true },
        ],
        filters: {
            typeFilter: '',
            descricaoFilter: ''
        },
        typesOptions: [
            { text: 'Todos', value: '' },
            { text: 'Convênio', value: 'convenio' },
            { text: 'Emenda Estadual', value: 'emenda_estadual' },
            { text: 'Emenda Federal', value: 'emenda_federal' },
            { text: 'PPAG', value: 'ppag' },
        ],
        items: [],
        itemSelected: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 20, 50],
        showFilters: true
    }),
    created() {
        this.listarUnidadesPrimariasPaginado();
    },
    watch: {
        page: async function (newValue) {
            this.page = newValue;
            await this.listarUnidadesPrimariasPaginado();
        },
        'filters.typeFilter': function (newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarUnidadesPrimariasPaginado();
            }
        },
        'filters.descricaoFilter': function (newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarUnidadesPrimariasPaginado();
            }
        }
    },
    computed: {
        computedHeaders() {
            return this.headers;
        },
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        }
    },
    methods: {
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        clearFilters() {
            this.filters = {
                typeFilter: '',
                descricaoFilter: ''
            };
            this.page = 1;
            this.listarUnidadesPrimariasPaginado();
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        getRowClass(item) {
            return item.id % 2 === 0 ? 'even-row' : 'odd-row';
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        formatCurrency(value) {
            if (!value && value !== 0) return 'R$ 0,00';
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        getValorDisponivelClass(value) {
            if (value > 0) return 'valor-positivo';
            if (value < 0) return 'valor-negativo';
            return 'valor-zero';
        },
        handleEditarUnidade() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/unidades-primarias/editar/${this.itemSelected[0].id}`);
            }
        },
        handleExportar() {
            this.$globalAlert('Não implementado!');
        },
        handlePageChange(newPage) {
            this.page = newPage;
            this.listarUnidadesPrimariasPaginado();
        },
        handleItemsPerPageChange(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarUnidadesPrimariasPaginado();
        },
        async listarUnidadesPrimariasPaginado() {
            try {
                const filter = this.prepareFormFilter();

                const response = await UnidadePrimariaService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os Unidades Primárias.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Unidades Primárias:', error);
            }
        },
        prepareFormFilter() {
            const filter = new FormData();
            filter.append("page", this.page);
            filter.append("items_per_page", this.itemsPerPage);

            if (this.filters.typeFilter) {
                filter.append("type", this.filters.typeFilter);
            }
            if (this.filters.descricaoFilter) {
                filter.append("descricao", this.filters.descricaoFilter);
            }

            return filter;
        },
        getTypeColor(type) {
            switch (type) {
                case 'ppag':
                    return 'green';
                case 'emenda_estadual':
                    return 'blue';
                case 'emenda_federal':
                    return 'orange';
                case 'convenio':
                    return 'purple';
                default:
                    return 'grey';
            }
        }
    }
};
